<template>
  <div class="l-nav">
    <div class="container">
      <div class="header_logo">
        <a :href="constants.MATCHA_SITE + languageName">
          <img src="@/static/images/logo.png" width="360" height="96" alt="MATCHA" >
        </a>
      </div>
      <div id="menuTrigger" class="header_menuTrigger icon-menu" v-on:click="openMenu"></div>
      <div id="menu" class="header_menu">
        <div class="menuHeader"> MATCHA
          <span class="menuClose icon-cancel" v-on:click="closeMenu"></span>
        </div>
        <!-- For User Login System  -->
        <div class="userMenu sp beforeLogin" id="beforeLogin" v-if="this.$store.state.user.accessToken == ''">
          <a class="login" href="/login">{{ $t('header.user.login') }}</a>
          <a class="sign-up" :href="constants.MATCHA_MEDIA_SSL_URL + languageName + '/user/index'">{{ $t('header.user.create_account') }}</a>
        </div>
        <div class="menuGroup userMenu sp" v-else>
          <ul id="dropdownMenu" class="dropdownMenu">
            <li>
              <div class="menuTitle arrow" @click="showDropDown($event)">{{ $t('マイページ') }}</div>
              <ul class="dropdown top_header">
                <li><a :href="'/'">{{$t('header.user.add_to_favorite')}}</a></li>
                <li><a :href="'/settings'">{{$t('header.user.settings_modification')}}</a></li>
                <li class="top_menu_listall">
                  <a href="javascript:;" @click.prevent="logout()">{{$t('header.user.logout')}}
                    <span></span>
                  </a>
                </li>  
              </ul>
            </li>
          </ul>
        </div>


        
        <div class="menuGroup mainMenu">
          <ul id="dropdownMenu" class="dropdownMenu">
            <li>

              <div class="menuTitle arrow"  @click="showDropDown($event)">{{ $t('header.menu.area') }}</div>
              <ul class="dropdown top_header">
                <li v-for="(region,index) in $t('header.area_list')" :key="index">
                  <a :href="constants.MATCHA_MEDIA_SSL_URL + languageName + '/list/?region=' + region.id + '&category=all'">{{ region.name }}</a>
                </li>
                <li class="top_menu_listall">
                  <a :href="constants.MATCHA_MEDIA_SSL_URL + languageName + '/list/region'">{{$t('すべてのエリア')}}<span></span></a>
                </li>
              </ul>
              <li>

              <div class="menuTitle arrow" @click="showDropDown($event)">{{ $t('header.menu.interest') }}</div>
              <ul class="dropdown">
                <li v-for="(interest, index) in $t('header.interest_list')" :key="index">
                  <a :href="constants.MATCHA_MEDIA_SSL_URL + languageName + '/list/?region=all&category=' + interest.id">{{ interest.name }}</a>
                </li>
                <li class="top_menu_listall">
                  <a :href="constants.MATCHA_MEDIA_SSL_URL + languageName + '/list/category'">{{$t('すべてのカテゴリー')}}<span></span></a>
                </li>                
              </ul>

            </li>
            <li>
              <div class="menuTitle arrow" @click="showDropDown($event)">{{ $t('header.menu.travel_tips') }}</div>
              <ul class="dropdown">
                <li v-for="(travel_tips, index) in $t('header.travel_tips_list')" :key="index">
                  <a :href="constants.MATCHA_MEDIA_SSL_URL + languageName + '/list/index?' + 'region=all&category=' + travel_tips.id">{{ travel_tips.name }}</a>
                </li>
              </ul>
            </li>
            <li v-if="isShowBookingMenu()">
              <div class="menuTitle arrow" @click="showDropDown($event)">{{ $t('header.menu.booking') }}</div>
              <ul class="dropdown">
                <li><a class="menuTitle" :href="constants.MATCHA_MEDIA_SSL_URL + languageName + '/booking'">{{ $t('header.menu.booking') }}</a></li>
                <li><a class="menuTitle" :href="$t('header.booking_list.0.url')" target="_blank">{{ $t('header.booking_list.0.name') }}</a></li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="menuGroup company">
          <div class="menuGroupLabel">{{ $t('header.company_profile') }}</div>
          <ul>
            <li><a href="https://company.matcha-jp.com/company/">{{ $t('header.company_profile') }}</a></li>
            <li><a href="https://www.wantedly.com/companies/matcha/projects">{{ $t('header.recruit') }}</a></li>
            <li><a href="https://company.matcha-jp.com/info/">{{ $t('header.contact_us') }}</a></li>
          </ul>
        </div>
      </div>
      <div id="menuMask" v-on:click="closeMenu"></div>

      <div class="userMenu pc " id="beforeLogin" v-if="this.$store.state.user.accessToken == ''">
        <a class="login" :href="'/login'">{{$t('header.user.login')}}</a>
      </div>      

      <div class="menuGroup userMenu pc" v-if="this.$store.state.user.accessToken != ''">
        <ul id="dropdownMenu" class="dropdownMenu">
          <li>
            <div class="menuTitle arrow"><i class="icon-user"></i></div>
          <vue-slide-up-down :dropDownActive="dropDownActive" :duration="1000">
            <ul class="dropdown top_header">
              <li><a :href="'/'">{{$t('header.user.add_to_favorite')}}</a></li>
              <li><a :href="'/settings'">{{$t('header.user.settings_modification')}}</a></li>
              <li class="top_menu_listall">
                <a href="javascript:;" @click.prevent="logout()">{{$t('header.user.logout')}}
                  <span></span>
                </a>
              </li>  
            </ul>
           </vue-slide-up-down>
          </li>
        </ul>
      </div>
      <form :action="constants.MATCHA_MEDIA_SSL_URL + languageName + '/search/?'" method="get" class="header_search icon-search">
        <input type="search" name="keyword" :placeholder="$t('header.search')">
        <span class="underline"></span>
        <button class="icon-search" type="submit"></button>
      </form>
    </div>
  </div>
</template>

<script>
import * as constants from '@/constants'
import { mapState, mapGetters, mapMutations } from 'vuex'
import Cookie from 'js-cookie'
import VueSlideUpDown from 'vue-slide-up-down'
import cognitoUser from '@/api/cognito-user'
import user from '@/api/user'

export default {
  name: 'footer',
  mounted(){
    this.$gtm.trackEvent({'isMember': 'true'});
  },

  components:{
    VueSlideUpDown
  },

  data () {
    return {
      constants: constants,
      dropDownActive:false,
      languageName: this.$store.state.languageName
    }
  },
  computed:{
    ...mapState(['user']),
    ...mapGetters({
      email: 'user/email',
      accessToken: 'user/accessToken'
    }),
  },  
  methods: {
    showDropDown: function(event){
      var e = event.target;
      this.dropDownActive = !this.dropDownActive;
      var ua = navigator.userAgent;
      if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
        if(this.dropDownActive){
          e.classList.add("arrow-down")
          e.nextElementSibling.style.display = "block";
        }else{
          e.classList.remove("arrow-down")
          e.nextElementSibling.style.display = "none";
        }
      }
    },
    isShowBookingMenu: function () {
      return ['jp', 'en', 'tw'].indexOf(this.languageName) >= 0
    },
    openMenu: function () {
      let menu = document.getElementById('menu')
      menu.style.left = '0'
      let mask = document.getElementById('menuMask')
      mask.style.display = 'block'
    },
    closeMenu: function () {
      let menu = document.getElementById('menu')
      menu.style.left = '-280px'
      let mask = document.getElementById('menuMask')
      mask.style.display = 'none'
    },
    logout (e) {
      let provider = this.$store.state.userMeta.provider
      // this.$store.dispatch('logout')
      // console.log(process.env.COOKIES_DOMAIN)
      this.$store.dispatch('logout').then((result) => {
        Cookie.remove('CognitoIdentity.Provider', { domain: process.env.COOKIES_DOMAIN })
        Cookie.remove('CognitoIdentity.accessToken', { domain: process.env.COOKIES_DOMAIN })
        Cookie.remove('CognitoIdentity.cognitoIdentiyId', { domain: process.env.COOKIES_DOMAIN })
        Cookie.remove('CognitoIdentity.sns_registration', { domain: process.env.COOKIES_DOMAIN })
        Cookie.remove('CognitoIdentity.s_stamp', { domain: process.env.COOKIES_DOMAIN })
        if(provider === 'accounts.google.com' || provider === 'graph.facebook.com'){
          Cookie.set('ulso', 'true', { domain: process.env.COOKIES_DOMAIN });
        }

        // console.log(result)
        window.location.href = process.env.MATCHA_MAIN_SITE+ '/' + this.languageName
      }).catch((err) =>{
        // console.log(err)
      })
    },  
  },
}
</script>



// WEBPACK FOOTER //
// src/components/common/Header.vue